export default __webpack_public_path__ + "static/media/(29).e4f52bd7.jpeg";